export default {
  list: [
    {
      title: 'صادرات',
      value: 'SADERAT'
    },
    {
      title: 'درگاه تست',
      value: 'TEST_GATEWAY'
    },
    {
      title: 'ملت',
      value: 'MELLAT'
    }
  ]
};
